import {Link} from "react-router-dom";
import {CheckCircle2} from "lucide-react";
import {fmtDate, money} from "@/lib/inner";

export const BookingSuccess = ({done}) => (
  <main className="success-page">
    <div className="success-mark"><CheckCircle2/></div>
    <p className="eyebrow">BOOKING BERHASIL</p>
    <h1>Sudah tercatat,<br/><em>sampai bertemu.</em></h1>
    <p className="lead">Status booking kamu <strong>{{completed: "Selesai", arrived: "Sudah tiba", in_service: "Sedang dilayani"}[done.status] || "Terkonfirmasi"}</strong>. Simpan bukti ini untuk ditunjukkan saat datang.</p>
    <div className="receipt" data-testid="booking-confirmation">
      <div><span>Kode booking</span><strong data-testid="receipt-code">{done.code}</strong></div>
      <div><span>Outlet</span><strong>{done.branch_name}</strong></div>
      <div className="receipt-services"><span>Perawatan</span><ul>{done.services.map(s => <li key={s.id}>{s.name}<b>{money(s.price)}</b></li>)}</ul></div>
      <div><span>Jadwal</span><strong>{fmtDate(done.date)} · {done.start_time} WIB</strong></div>
      {done.is_member && <div><span>Diskon member {done.discount_percent}%</span><strong data-testid="receipt-discount">−{money(done.discount)}</strong></div>}
      <div><span>Total perawatan</span><strong data-testid="receipt-total">{money(done.price)}</strong></div>
      {done.dp_paid > 0 && <div><span>DP dibayar</span><strong data-testid="receipt-dp">{money(done.dp_paid)}</strong></div>}
      <div><span>Sisa bayar di outlet</span><strong data-testid="receipt-remaining">{money(done.price - (done.dp_paid || 0))}</strong></div>
    </div>
    {done.is_member && <p className="muted">Tunjukkan kartu/identitas member saat datang agar diskon dapat diberikan.</p>}
    <button className="primary-btn" data-testid="save-booking-button" onClick={() => window.print()}>Simpan Bukti Booking</button>
    <Link className="subtle-link" to="/">Kembali ke beranda</Link>
  </main>
);
